import React from 'react';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider } from '@apollo/client';
import ReactOnRails from 'react-on-rails';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import getMessages from '../../lib/i18n/getMessages';
import MarketplaceHomeContainer from '../../containers/coachLed/MarketplaceHomeContainer.jsx';

const client = new ApolloClient({
  link: new HttpLink({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': ReactOnRails.authenticityToken() },
  }),
  cache: new InMemoryCache(),
});

const CoachLedMarketplacePage = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  return (
    <IntlProvider locale={locale} messages={getMessages(locale)}>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <MarketplaceHomeContainer {...props} />
        </BrowserRouter>
      </ApolloProvider>
    </IntlProvider>
  );
};
export default CoachLedMarketplacePage;
